import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "submit", "form"]

    connect() {
        this.enableInput = this.enableInput.bind(this)
    }

    keydown(event) {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault()
            this.send()
        }
    }

    suggest(event) {
        const text = event.currentTarget.dataset.suggestion
        this.inputTarget.value = text
        this.send()
    }

    send() {
        if (this.inputTarget.value.trim() === "") return
        this.formTarget.requestSubmit()
        this.disableInput()
    }

    disableInput() {
        this.inputTarget.disabled = true
        this.submitTarget.disabled = true
        this.inputTarget.classList.add("opacity-50")
    }

    enableInput() {
        this.inputTarget.disabled = false
        this.submitTarget.disabled = false
        this.inputTarget.classList.remove("opacity-50")
        this.inputTarget.value = ""
        this.inputTarget.focus()
    }
}
